///
/// EarthBrowser
///
/// Created by Matt Giger on 3/2/2025
/// Copyright (c) 2025 Geodata Labs
///

/**
 * Generates a hash code for a string using a modified djb2 algorithm.
 * This is a simple but effective hash function for strings.
 *
 * @param str - The string to hash
 * @returns A string representation of the 32-bit hash value
 */
export function hashString(str: string): string {
    let hash = 5381

    for (let i = 0; i < str.length; i++) {
        // hash * 33 + char
        hash = ((hash << 5) + hash) + str.charCodeAt(i)
        // Convert to 32-bit integer
        hash = hash >>> 0
    }

    return hash.toString(16).padStart(8, '0')
}

/**
 * Generates a simple hash code for a string using a simple sum of character codes.
 * This is a simple but effective hash function for strings.
 *
 * @param value - The string to hash
 * @returns A number representation of the hash value
 */
export function simpleHash(value: string): number {
    let res = 0;
    for (let i = 0; i < value.length; i++) {
        res += value.charCodeAt(i);
    }
    return res % 2048;
}